import { ApisauceInstance } from 'apisauce';

const updateCommitment = (c: Commitment, api: ApisauceInstance) => {
  return api.patch(`/v1/commitments/update_commitment?commitment_id=${c.id}`, {
    commitment_data: c,
  });
};

export default updateCommitment;
